module.exports = __webpack_public_path__ + "static/img/mastercard.e8a3156.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mastercard.png
// module id = wA9G
// module chunks = 1